// --------------------------------------------------------
// DROPDOWN CUSTOM - CustomDropdown
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";
import { useState } from "react";
import { ReactComponent as Check } from "../../assets/imgs/check.svg";
import Colors from "../../constants/Colors";
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// DROPDOWN CUSTOM INTERFACE
// --------------------------------------------------------

interface ICustomDropdown {
  value: any;
  onChange: any;
  items: any[];
  disabled: boolean;
  backgroundColor?: string;
  placeholder?: string;
  textColor?: string;
  containerStyle?: any;
  isModal?: boolean;
  style?: any;
  error?: any;
  allValue?: any;
}

/**
/**
 * A component that renders a Custom Dropdown.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const CareLineDropdown = ({
  value,
  onChange,
  placeholder = "",
  error = "",
  items = [],
  disabled,
  backgroundColor = Colors.lightBlue,
  textColor = Colors.SPM800,
  style = {},
  containerStyle = {},
  allValue = [],
  isModal
}: ICustomDropdown) => {
  // --------------------------------------------------------
  // DROPDOWN CUSTOM PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  // --------------------------------------------------------

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <>
      <FormControl style={{ ...containerStyle }}>
        {(value === null || value === undefined) && (
          <InputLabel style={{ color: "#07365F66" }}>{placeholder}</InputLabel>
        )}

        <Select
          size="medium"
          error={error}
          defaultValue={""}
          native={false}
          disabled={disabled}
          open={isOpen}
          IconComponent={() => (
            <KeyboardArrowDownIcon
              onClick={disabled ? undefined : handleOpen}
              style={{ cursor: disabled ? "auto" : "pointer", marginRight: 1 }}
            />
          )}
          label={placeholder}
          onOpen={false ? () => {} : handleOpen}
          onClose={handleClose}
          value={value}
          style={{
            backgroundColor: "#F3FAFF",
            borderRadius: 8,
            color: textColor,
            ...style,
          }}
          onChange={(event) => {
            onChange(event.target.value);
          }}
          renderValue={(selected: any) => selected.nome ? selected.nome : selected.alergeno ? selected.alergeno : selected.nomeFantasia}
        >
          {items.map((item, index) => {
            const isSelected: boolean = item?.id === value?.id;
            return (
              <MenuItem
                key={index}
                value={item}
                dense
                style={{
                  height: 15,
                  backgroundColor: isSelected ? "#F3FAFF" : "",
                  color: Colors.SPM800,
                }}
              >
                <ListItemText
                  primary={item.nome ? item.nome : item.alergeno ? item.alergeno : item.nomeFantasia}
                  style={{ color: Colors.SPM800 }}
                />
                {isSelected && <Check />}
              </MenuItem>
            );
          })}
          {/* Segunda lista, usado para o value "Todos" */}
          {allValue.length > 0 &&
            allValue.map((item: any, index: number) => {
              const isSelected: boolean = item?.id === value?.id;
              return (
                <MenuItem
                  key={index}
                  value={item}
                  dense
                  style={{
                    height: 15,
                    backgroundColor: isSelected ? "#F3FAFF" : "",
                    color: Colors.SPM800,
                  }}
                >
                  <ListItemText
                    primary={item.nome || item.alergeno}
                    style={{ color: Colors.SPM800 }}
                  />
                  {isSelected && <Check />}
                </MenuItem>
              );
            })}
        </Select>
      </FormControl>
    </>
  );
  // --------------------------------------------------------
};

export default CareLineDropdown;
